import { useContext, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import classNames from "classnames";
import { motion } from "framer-motion";

import { ResizingContainerContext } from "./SharedResizingArea";

export function SharedResizingChild({
  children,
  resizeKey,
  show,
  side = "left",
  onAnimationComplete,
}) {
  const { animating, screenToShow, setNextHeight, lessDrama } = useContext(
    ResizingContainerContext
  );

  const childRef = useRef();

  useEffect(() => {
    if (show) {
      setNextHeight(childRef.current.getBoundingClientRect().height);
    }
  }, [show, setNextHeight]);

  const showChild = {
    x: 0,
    position: "relative",
    opacity: 1,
    transition: { delay: lessDrama ? 0.1 : 0.05 },
  };

  const dramaFactor = lessDrama ? 20 : 100;

  const hideChild = {
    position: "absolute",
    opacity: 0,
    x: side === "left" ? dramaFactor * -1 + "%" : dramaFactor + "%",
    transition: { type: "tween", duration: 0.2, ease: "easeOut" },
  };

  return (
    <ChildContainer
      ref={childRef}
      className={classNames({ hidden: !animating && !show })}
      initial={screenToShow === resizeKey ? showChild : hideChild}
      animate={screenToShow === resizeKey ? showChild : hideChild}
      onAnimationComplete={onAnimationComplete}
    >
      {children}
    </ChildContainer>
  );
}

const ChildContainer = styled(motion.div)`
  width: 100%;
  flex-shrink: 0;
  position: absolute;
  box-sizing: border-box;
  &.hidden {
    visibility: hidden;
  }
`;
